import { render } from "./AccountSidebarElement.vue?vue&type=template&id=1f38d460"
import script from "./AccountSidebarElement.vue?vue&type=script&lang=js"
export * from "./AccountSidebarElement.vue?vue&type=script&lang=js"

import "./AccountSidebarElement.vue?vue&type=style&index=0&id=1f38d460&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__